
export const HasIconMixin = (target) => class extends target {
  static get fields() {
    return [
      { name: "hasContacts", persist: false },
      { name: "hasNotes", persist: false },
      { name: "entityType", persist: false},
    ]
  }

  get hasContacts() {
    // For group headers this.contacts will be undefined
    return Boolean(this.contacts?.length)
  }

  get hasNotes() {
    return this.project?.boardNotesStore.some(note => note[this.entityType] === this.id);
  }
}
